import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageActionEdit.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchActionQuery,
  useFetchEventQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";
// import dayjs from "dayjs";

const PageActionEdit: React.FC = () => {
  const { eventId, id } = useParams<{ id: string; eventId: string }>();

  const { data: action, isFetching: isFecthingAction } = useFetchActionQuery(
    id,
    {
      skip: !id,
    },
  );

  const { data: event, isFetching: isFetchingEvent } = useFetchEventQuery(
    Number(eventId),
    {
      skip: !eventId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const { onSubmit, isLoading } = useCrudAction(
    undefined,
    undefined,
    Number(eventId),
    true,
    action,
  );

  const defaultValues: SchemaFormAction = useMemo(() => {
    if (!action) {
      return {
        dateAsked: dayjs(),
        date: dayjs(),
        causeType: "CORRECTIF",
        title: "",
        description: "",
        effacity: "",
        pilote: "",
        performer: "",
        event: String(eventId),
      };
    }
    return {
      dateAsked: dayjs(action.dateAsked),
      date: dayjs(action.date),
      causeType: action.causeType,
      title: action.title || "",
      description: action.description || "",
      effacity: action.effacity || "",
      pilote: action.pilote || "",
      performer: String(action.performer?.id),
      event: String(eventId),
    };
  }, [action, eventId]);

  const isPageLoading =
    isFecthingAction || isFetchingEvent || isFetchingPorformers;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="action"
        actionName={action?.title}
        actionId={Number(id)}
        eventName={event?.name}
        eventId={Number(eventId)}
      />
      {!isPageLoading && (
        <FormActions
          isEditMode
          onSubmit={onSubmit}
          isLoading={isLoading}
          defaultValues={defaultValues}
          performers={dataPerformers || []}
        />
      )}
    </PageLayout>
  );
};

export default PageActionEdit;
